import propTypes from 'prop-types';
import React from 'react';
import { Dropdown, Form, Label, Table } from 'semantic-ui-react';
import userService from '../../services/userService';
import productInfos from '../Protected/projet/productInfos';
import { TechnicalInfoIcon } from './TechnicalInfoIcon';

const ComponentTable = (props) => {
  const {
    worktype,
    t,
    match: {
      params: {
        env,
      },
    },
    components,
  } = props;

  function onClickTechnicalInfo(link) {
    if (link) {
      const windowRef = window.open(link, '_blank');
      windowRef.focus();
    }
  }

  const body = [];

  const componentsData = Number(worktype) === 2
    ? productInfos[env].formula.rtMax.components
    : productInfos[env].formula.rtPlus.components;
  const values = Object.values(componentsData);

  if (values) {
    values.forEach((componentData, index) => {
      const selected = components[index][componentData.componentKey];
      const options = components[index][componentData.listKey] || [];

      let selectedOption = null;

      if (componentData.hasList && options && Array.isArray(options) && selected) {
        const option = options.find(opt => opt.key === selected.id);
        if (option) {
          selectedOption = option.value;
        }
      }

      body.push((
        <Table.Row key={componentData.key}>
          <Table.Cell>
            {index + 1}
            .
          </Table.Cell>
          <Table.Cell className={Number(worktype) === 2 ? 'cellTablertMax' : 'cellTablertPlus'}>
            {t(componentData.key)}
            <TechnicalInfoIcon
              t={t}
              onClick={
                () => onClickTechnicalInfo(
                  selected ? selected.link : ''
                )
              }
            />
            <br />
            {componentData.hasList && (
              <Dropdown
                search
                selection
                disabled={!componentData.enableList}
                options={Array.isArray(options) ? options : []}
                value={selectedOption || []}
                onChange={components[index].onChangeList}
              />
            )}
          </Table.Cell>
          <Table.Cell className="cellTable">
            {Number(components[index][componentData.usedKey] || 0).toFixed(0)}
            {' '}
            {t(componentData.usedLabel)}
          </Table.Cell>
          <Table.Cell className="cellTableQuantity">
            {`${Number(components[index][componentData.nbKey] || 0).toFixed(0)} `}
            {' '}
            {t(componentData.nbLabel)}
          </Table.Cell>
          <Table.Cell className={Number(worktype) === 2 ? 'cellTablertMax' : 'cellTablertPlus'}>
            <Form className="inputInTable">
              <Form.Input
                type="number"
                onClick={e => e.target.select()}
                width={8}
                step={0.10}
                disabled={userService.isUser() || userService.getTokenCleared() === null}
                value={
                    selected && selected.noFormat
                      ? selected.price
                      : Number((selected && selected.price) || 0).toFixed(2)
                  }
                onChange={(_, val) => {
                  components[index].onChange(val.value);
                }}
                onBlur={() => {
                  components[index].onBlur();
                }}
              />
              <Label className={window.innerWidth <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                {t(componentData.priceLabel)}
              </Label>
            </Form>
          </Table.Cell>
          <Table.Cell className="cellTable">
            {(components[index][componentData.costKey] || 0).toFixed(2)}
            {' '}
            {t(componentData.costLabel)}
          </Table.Cell>
        </Table.Row>
      ));
    });
  }

  return (
    <div>
      <Table
        basic="very"
        className={Number(worktype) === 2 ? 'tableRtMaxSoluce' : 'tableRtPlusSoluce'}
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('table_title')}
            </Table.HeaderCell>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('table_title_quantity')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('table_title_unité')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('table_title_surface')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {body}
        </Table.Body>
      </Table>
    </div>
  );
};

ComponentTable.propTypes = {
  worktype: propTypes.string,
  t: propTypes.func,
  match: propTypes.shape({
    params: propTypes.shape({
      env: propTypes.string,
    }),
  }),
  components: propTypes.array,
};

export default ComponentTable;



// WEBPACK FOOTER //
// ./src/components/shared/ComponentTable.jsx